import { fetchWithAuthJson, fetchWithAuth } from "../context/FetchWithAuth";
import { baseUrl } from "../utils/config";

export const getAllReport = async ({
    lastCreatedAt,
    lastId,
    size = 10,
    keyword,
    serialNumber,
    status,
    startDate,
    endDate,
    groupId
}: {
    lastCreatedAt?: string,
    lastId?: string,
    size?: number,
    keyword?: string,
    serialNumber?: string,
    status?: string,
    startDate?: string,
    endDate?: string,
    groupId?: number
}) => {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Token expiré");

    const params = new URLSearchParams();
    params.append("size", size.toString());
    if (lastCreatedAt) params.append("lastCreatedAt", lastCreatedAt);
    if (lastId) params.append("lastId", lastId);
    if (keyword) params.append("keyword", keyword);
    if (serialNumber) params.append("serialNumber", serialNumber);
    if (status) params.append("status", status);
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    if (groupId) params.append("groupId", groupId.toString());

    const response = await fetchWithAuthJson(
        `${baseUrl}/app_api/v1/findAllReportKeyset?${params.toString()}`,
        {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`
            }
        }
    );

    return response;
};

export const getAllReportIntervention = async (id: string) => {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Token expirer");
    const response = await fetchWithAuthJson(`${baseUrl}/app_api/v1/findAllReportIntervention?id=${encodeURIComponent(id)}`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` }
    });

    return response;
}

export const getAllReportByGroup = async ({
    ids,
    lastCreatedAt,
    lastId,
    size = 10,
    keyword,
    serialNumber,
    status,
    startDate,
    endDate,
    groupId
}: {
    ids: string[],
    lastCreatedAt?: string,
    lastId?: string,
    size?: number,
    keyword?: string,
    serialNumber?: string,
    status?: string,
    startDate?: string,
    endDate?: string,
    groupId?: number
}) => {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Token expiré");

    const params = new URLSearchParams();
    ids.forEach(id => params.append("id", id));
    params.append("size", size.toString());
    if (lastCreatedAt) params.append("lastCreatedAt", lastCreatedAt);
    if (lastId) params.append("lastId", lastId);
    if (keyword) params.append("keyword", keyword);
    if (serialNumber) params.append("serialNumber", serialNumber);
    if (status) params.append("status", status);
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    if (groupId) params.append("groupId", groupId.toString());

    const url = `${baseUrl}/app_api/v1/findAllReportByGroupKeyset?${params.toString()}`;
    return fetchWithAuthJson(url, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` }
    });
};

export const getAllReportByUser = async ({
    id,
    lastCreatedAt,
    lastId,
    size = 10,
    keyword,
    serialNumber,
    status,
    startDate,
    endDate,
    groupId
}: {
    id: string,
    lastCreatedAt?: string,
    lastId?: string,
    size?: number,
    keyword?: string,
    serialNumber?: string,
    status?: string,
    startDate?: string,
    endDate?: string,
    groupId?: number
}) => {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Token expiré");

    const params = new URLSearchParams();
    params.append("userId", id);
    params.append("size", size.toString());
    if (lastCreatedAt) params.append("lastCreatedAt", lastCreatedAt);
    if (lastId) params.append("lastId", lastId);
    if (keyword) params.append("keyword", keyword);
    if (serialNumber) params.append("serialNumber", serialNumber);
    if (status) params.append("status", status);
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    if (groupId) params.append("groupId", groupId.toString());

    const url = `${baseUrl}/app_api/v1/findAllReportByUserKeyset?${params.toString()}`;
    return fetchWithAuthJson(url, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` }
    });
};

export const downloadPdf = async (id: string) => {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Token expirer");
    const response = await fetchWithAuth(`${baseUrl}/app_api/v1/downloadPdf?id=${encodeURIComponent(id)}`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` }
    });

    if (!response) return;

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'report_' + id + '.pdf');
    document.body.appendChild(link);
    link.click();
    link.remove();
}

export const getReportExcel = async (id: string, caseId: string) => {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Token expirer");
    const response = await fetchWithAuth(`${baseUrl}/app_api/v1/downloadExcel?id=${encodeURIComponent(id)}`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` }
    });

    if (!response) return;

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = url;
    a.download = `INTERVREPORT_${caseId}.xlsx`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
}

export const deleteReport = async (id: string) => {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Token expirer");
    const response = await fetchWithAuth(`${baseUrl}/app_api/v1/deleteReport?id=${encodeURIComponent(id)}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` }
    });

    return response;
}

export const getReportsCount = async ({
    keyword, serialNumber, status, startDate, endDate, groupId
}: {
    keyword?: string,
    serialNumber?: string,
    status?: string,
    startDate?: string,
    endDate?: string,
    groupId?: number
}) => {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Token expiré");

    const params = new URLSearchParams();
    if (keyword) params.append("keyword", keyword);
    if (serialNumber) params.append("serialNumber", serialNumber);
    if (status) params.append("status", status);
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    if (groupId !== undefined) params.append("groupId", String(groupId));

    const resp = await fetchWithAuthJson(`${baseUrl}/app_api/v1/countReports?${params.toString()}`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` }
    });
    return typeof resp === "number" ? resp : Number(resp);
};
